import React from "react";

interface ForgotPasswordHeaderProps {
  title: string;
  subtitle: string;
}

const ForgotPasswordHeader: React.FC<ForgotPasswordHeaderProps> = ({
  title,
  subtitle,
}) => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">{title}</h1>
      <p className="text-gray-600 text-sm">{subtitle}</p>
    </div>
  );
};

export default ForgotPasswordHeader;
